import { useEffect } from 'react';

// The tvod service sends the socket event before it has refreshed the active transactions cache
// that /mytransactions reads from, so revalidating immediately returns the old list.
export const TVOD_REVALIDATE_DELAY_MS = 2000;

export const useRevalidateOnTvodTransaction = (enabled: boolean, revalidate: () => unknown) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    const onTransactionCompleted = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => revalidate(), TVOD_REVALIDATE_DELAY_MS);
    };

    document.addEventListener('wss:tvod-transaction-completed', onTransactionCompleted);
    return () => {
      document.removeEventListener('wss:tvod-transaction-completed', onTransactionCompleted);
      clearTimeout(timeoutId);
    };
  }, [enabled, revalidate]);
};
